
document.addEventListener('DOMContentLoaded', () => {
    // Inject Styles
    if (!document.getElementById('cart-undo-styles')) {
        const style = document.createElement('style');
        style.id = 'cart-undo-styles';
        style.textContent = `
            .cart-undo-container {
                position: fixed;
                bottom: 30px;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                flex-direction: column;
                gap: 10px;
                z-index: 999999;
                width: 90%;
                max-width: 400px;
                pointer-events: none; /* Let clicks pass through container */
            }
            .cart-undo-toast {
                background: rgb(var(--color-background));
                color: rgb(var(--color-foreground));
                padding: 12px 24px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                gap: 16px;
                box-shadow: 0 4px 20px rgba(var(--color-shadow), 0.15);
                transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.4s ease;
                justify-content: space-between;
                border: 1px solid rgba(var(--color-foreground), 0.1);
                opacity: 0;
                transform: translateY(20px);
                pointer-events: auto; /* Re-enable clicks on toasts */
            }
            .cart-undo-toast.active {
                transform: translateY(0);
                opacity: 1;
            }
            .cart-undo-toast.removing {
                opacity: 0;
                transform: translateY(20px);
            }
            .cart-undo-toast__content {
                display: flex;
                align-items: center;
                gap: 12px;
                font-weight: 500;
                font-size: 1.4rem;
                flex: 1;
            }
            .cart-undo-toast__undo-btn {
                background: rgba(var(--color-foreground), 0.1);
                border: none;
                color: rgb(var(--color-foreground));
                padding: 6px 16px;
                border-radius: 4px;
                cursor: pointer;
                font-size: 1.3rem;
                font-weight: 600;
                transition: background 0.2s;
                white-space: nowrap;
            }
            .cart-undo-toast__undo-btn:hover {
                background: rgba(var(--color-foreground), 0.2);
            }
            .cart-undo-toast__undo-btn:disabled {
                opacity: 0.6;
                cursor: not-allowed;
            }
            @media (max-width: 768px) {
                .cart-undo-container {
                    bottom: 20px;
                    width: calc(100% - 40px);
                }
            }
        `;
        document.head.appendChild(style);
        
        // Create container if it doesn't exist
        if (!document.querySelector('.cart-undo-container')) {
            const container = document.createElement('div');
            container.className = 'cart-undo-container';
            document.body.appendChild(container);
        }
    }

    // Event Delegation
    document.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('xo-cart-remove');
        if (removeBtn) {
            handleRemoveClick(removeBtn);
        }
    });
});

function handleRemoveClick(btn) {
    const variantId = btn.dataset.variantId;
    const quantity = parseInt(btn.dataset.quantity);
    const title = btn.dataset.title;
    const properties = btn.dataset.properties ? JSON.parse(btn.dataset.properties) : {};
    
    // Check if variantId is valid
    // if (variantId) {
    //     // Queue the toast after a short delay to allow UI to update
    //     setTimeout(() => {
    //         showUndoToast(title, variantId, quantity, properties);
    //     }, 500);
    // }
}

function showUndoToast(title, variantId, quantity, properties) {
    const container = document.querySelector('.cart-undo-container');
    
    const toast = document.createElement('div');
    toast.className = 'cart-undo-toast';
    toast.setAttribute('role', 'alert');
    toast.innerHTML = `
        <div class="cart-undo-toast__content">
            <span>${title} removed</span>
        </div>
        <button class="cart-undo-toast__undo-btn" aria-label="Undo removal of ${title}">Undo</button>
    `;

    container.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => toast.classList.add('active'));

    const undoBtn = toast.querySelector('.cart-undo-toast__undo-btn');
    undoBtn.addEventListener('click', () => {
        undoRemoval(variantId, quantity, properties, toast);
    });

    // Auto dismiss after 10 seconds
    const timeout = setTimeout(() => {
        dismissToast(toast);
    }, 10000);
    
    toast.dataset.timeoutId = timeout;
}

function dismissToast(toast) {
    if (toast) {
        toast.classList.remove('active');
        toast.classList.add('removing');
        setTimeout(() => {
            if (toast.parentNode) toast.parentNode.removeChild(toast);
        }, 400);
    }
}

function undoRemoval(variantId, quantity, properties, toast) {
    const undoBtn = toast.querySelector('.cart-undo-toast__undo-btn');
    undoBtn.textContent = 'Restoring...';
    undoBtn.disabled = true;

    // Clear auto-dismiss
    if (toast.dataset.timeoutId) clearTimeout(parseInt(toast.dataset.timeoutId));

    const formData = {
        'items': [{
            'id': variantId,
            'quantity': quantity,
            'properties': {}
        }]
    };

    fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        if (data.status) { // Error
            throw new Error(data.description || 'Failed to restore item');
        }
        
        // Success
        
        // Show success state
        const content = toast.querySelector('.cart-undo-toast__content');
        const btn = toast.querySelector('.cart-undo-toast__undo-btn');
        btn.remove();
        content.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style="color: #28a745;"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
            <span>Item restored</span>
        `;
        
        
        // Refresh Cart UI
        refreshCartUI();
        
        // Dismiss after a short delay
        setTimeout(() => {
            dismissToast(toast);
        }, 2000);
    })
    .catch(error => {
        console.error('Undo failed:', error);
        
        // Update toast to show error state
        const content = toast.querySelector('.cart-undo-toast__content');
        const btn = toast.querySelector('.cart-undo-toast__undo-btn');
        
        // Remove "Restoring..." button
        btn.remove();
        
        // Add "Failed" badge
        const badge = document.createElement('span');
        badge.style.cssText = 'background: #666; color: #fff; padding: 2px 6px; border-radius: 4px; font-size: 12px; margin-left: auto;';
        badge.textContent = 'Failed';
        content.appendChild(badge);
        
        // Show modal after a brief delay
        setTimeout(() => {
             dismissToast(toast);
             showErrorModal('Could not undo removal. Please try adding the item again manually.');
        }, 1000);
    });
}

function showErrorModal(message) {
    const existing = document.getElementById('cart-error-modal');
    if (existing) existing.remove();

    const modal = document.createElement('div');
    modal.id = 'cart-error-modal';
    modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999999;
        backdrop-filter: blur(2px);
    `;
    
    modal.innerHTML = `
        <div style="background: rgb(var(--color-background)); color: rgb(var(--color-foreground)); padding: 24px; border-radius: 8px; max-width: 400px; width: 90%; box-shadow: 0 4px 20px rgba(0,0,0,0.2);">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px; font-size: 1.2rem; opacity: 0.8;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                ${window.location.host}
            </div>
            <p style="margin-bottom: 24px; font-size: 1.6rem; line-height: 1.5;">${message}</p>
            <div style="display: flex; justify-content: flex-end;">
                <button class="cart-error-modal__ok" style="background: #00b8a9; color: white; border: none; padding: 10px 24px; border-radius: 4px; font-weight: 600; cursor: pointer;">OK</button>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
    
    // Trap focus and handle close
    const okBtn = modal.querySelector('.cart-error-modal__ok');
    okBtn.focus();
    
    const close = () => modal.remove();
    okBtn.addEventListener('click', close);
    modal.addEventListener('click', (e) => {
        if (e.target === modal) close();
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
    }, { once: true });
}

function refreshCartUI() {
    // Fetch the current page to get updated cart HTML
window.location.reload()
}
